@if (loading()) {
  <kendo-loader
    [type]="'infinite-spinner'"
    [size]="'large'"
  ></kendo-loader>
} @else if (isStatusConfigured() && savedConfiguration()) {
  <div class="ingestor-configured-container">
    <div class="configured-header">
      <div class="success-icon">
        <i class="k-icon k-i-check-circle k-icon-xxxl"></i>
      </div>
      <h2 class="success-title">Successfully Connected</h2>
      <p class="success-message">
        Your {{ savedConfiguration()?.ingestor_integration?.display_name }} integration is properly configured and ready
        to use.
      </p>
      @if (showElasticSyncWarning()) {
        <p class="elastic-sync-warning">{{ elasticSyncStatusLabel() }}</p>
      }
      @if (savedConfiguration()?.elastic_last_sync_error) {
        <p class="elastic-sync-error">{{ savedConfiguration()?.elastic_last_sync_error }}</p>
      }
      @if (canRetryElasticSync()) {
        <button
          kendoButton
          themeColor="primary"
          [disabled]="resyncLoading()"
          (click)="retryElasticSync()"
        >
          Retry Elastic provisioning
        </button>
      }
      @if (actionMessage()) {
        <p [class]="actionMessageType() === 'error' ? 'elastic-sync-error' : 'elastic-sync-info'">
          {{ actionMessage() }}
        </p>
      }
    </div>

    <div class="configuration-details-card">
      <h3>Configuration Details</h3>
      <div class="details-grid">
        <div class="detail-row">
          <span class="detail-label">Name:</span>
          <span class="detail-value">{{ savedConfiguration()?.ingestor_integration?.display_name }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Status:</span>
          <span class="detail-value">{{ savedConfiguration()?.configuration_status?.name }}</span>
        </div>
        @if (elasticSyncStatusLabel()) {
          <div class="detail-row">
            <span class="detail-label">Elastic Status:</span>
            <span class="detail-value">{{ elasticSyncStatusLabel() }}</span>
          </div>
        }
        <div class="detail-row">
          <span class="detail-label">Created By:</span>
          <span class="detail-value">{{ savedConfiguration()?.created_by }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Created:</span>
          <span class="detail-value">{{ savedConfiguration()?.created_at }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Updated:</span>
          <span class="detail-value">{{ savedConfiguration()?.updated_at }}</span>
        </div>
      </div>
    </div>
  </div>
}
